<div class="storage-attachment-input">
  <!-- Title (opzionale) -->
  @if (showTitle && titleKey) {
    <h6 class="mb-2">{{ titleKey | translate }}</h6>
  }

  <!-- Label con info popover -->
  @if (!hideLabel) {
    <div class="d-flex align-items-center mb-2">
      <label [for]="inputId" class="form-label mb-0">{{ labelKey | translate }}</label>
      @if (infoPopover) {
        <i
          class="ms-2 bi bi-info-circle text-muted"
          [attr.data-bs-toggle]="'popover'"
          [attr.data-bs-content]="infoPopover"
          style="cursor: pointer"
        ></i>
      }
    </div>
  }

  <!-- File input e stato upload -->
  <div class="upload-container">
    <!-- Input file - visibile solo se non c'è un file caricato -->
    @if (!isUploadComplete) {
      <div class="file-input-wrapper">
        <input
          [id]="inputId"
          type="file"
          class="form-control"
          [accept]="accept"
          [disabled]="disabled || isUploading"
          (change)="onFileSelected($event)"
          />
      </div>
    }

    <!-- Progress indicator -->
    @if (selectedFile && (isUploading || isUploadComplete)) {
      <div class="upload-status mt-3">
        <div class="d-flex align-items-center">
          <!-- Circular progress -->
          <div class="me-3">
            <app-circular-progress
              [value]="uploadProgress"
              [total]="100"
              [showPercentage]="true"
              [size]="80"
              [thickness]="12"
            ></app-circular-progress>
          </div>
          <!-- File info e status -->
          <div class="flex-grow-1">
            <div class="fw-bold">{{ selectedFile.name }}</div>
            <div class="text-muted small">
              {{ uploadStatus || 'In attesa...' }}
            </div>
            @if (isUploadComplete && uploadedFilePath) {
              <div class="text-success small mt-1">
                <i class="bi bi-check-circle-fill me-1"></i>
                File caricato: {{ uploadedFilePath }}
              </div>
            }
          </div>
          <!-- Pulsante rimuovi -->
          @if (!isUploading) {
            <div class="ms-2">
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeFile()" [disabled]="disabled">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          }
        </div>
      </div>
    }

    <!-- Pulsante upload manuale (se autoUpload è false) -->
    @if (selectedFile && !autoUpload && !isUploading && !isUploadComplete) {
      <div class="mt-2">
        <button type="button" class="btn btn-primary" (click)="startUpload()" [disabled]="disabled">
          <i class="bi bi-cloud-upload me-2"></i>
          Carica file
        </button>
      </div>
    }

    <!-- Error message -->
    @if (error) {
      <div class="alert alert-danger mt-3 mb-0" role="alert">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        {{ error }}
      </div>
    }
  </div>
</div>
